import React, { useState } from 'react';
import PropTypes from 'prop-types';
import QuestLeaderboardModal from 'containers/QuestLeaderboardModal';
import A11yFontIcon from 'components/A11yFontIcon';
import './QuestLeaderboardButton.css';

function QuestLeaderboardButton({ quest, endDateUtc, claimEndDate }) {
  const [show, setShow] = useState(false);
  return (
    <>
      <button
        className="btn button-color-yellow quest-leaderboard-button"
        type="button"
        onClick={() => setShow(true)}
      >
        VIEW LEADERBOARD <A11yFontIcon icon="trophy" alt="" />
      </button>
      {show && (
        <QuestLeaderboardModal
          show={show}
          quest={quest}
          endDateUtc={endDateUtc}
          claimEndDate={claimEndDate}
          onClose={() => setShow(false)}
        />
      )}
    </>
  );
}

QuestLeaderboardButton.propTypes = {
  quest: PropTypes.object,
  endDateUtc: PropTypes.string,
  claimEndDate: PropTypes.string
};

export default QuestLeaderboardButton;
